// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-details--modal--1Kc5doOP {\n  background-color: '#6fc6da';\n}\n.question-details--question--1gVxy5vY {\n  font-family: 'museo-sans', helvitica, sans-serif;\n  overflow: auto;\n  padding: 1em;\n  margin: 1em;\n}\n.question-details--question--1gVxy5vY p {\n  margin: 1em;\n}\n", ""]);
// Exports
exports.locals = {
	"modal": "question-details--modal--1Kc5doOP",
	"question": "question-details--question--1gVxy5vY"
};
module.exports = exports;
